<template>
  <div>
    <div class="card card-base">
      <div class="card-body p-1">
        <h4 class="card-title mb-3 text-white text-uppercase" style="font-weight:700"><span
            style="color: #0092f7">Assign</span> Float</h4>
        <form @submit.prevent="">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control theme-form-input"
                       v-model="assignedTo" id="floatingTextInput1"
                       placeholder="Cashier" required readonly>
                <label for="floatingTextInput1">Assigned To</label>
              </div>
            </div>
          </div>
          <div class="form-floating mb-3">
            <input type="number" step="0.01" class="form-control theme-form-input"
                   v-model="floatAmount" id="floatAmount"
                   placeholder="Amount"
                   required>
            <label for="floatAmount">Float Amount</label>
          </div>
          <div class="text-center submit-btns">
            <button :disabled="loading" class="btn" @click="startShift">
              <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Start Shift
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatAssignForm",
  data() {
    return {
      assignedTo: '',
      floatAmount: 0,
      supervisorPassword: 'Auto',
      allowed: true,
      users: [],
      loading : false ,
      currentDate: '',
      currentTime: '',
    }
  },
  beforeMount() {
    this.checkFloat()
    this.updateDateTime()
    setInterval(this.updateDateTime, 60000) // Update every minute
  },
  computed: {
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
    set() {
      return this.$store.getters.getDeviceSettings
    },
    deviceName() {
      return this.set?.PC || 'POS Terminal'
    },
  },
  methods: {
    async checkFloat() {
      this.loading = true;
      return this.$store.dispatch('checkUserFloat')
          .then(async (res)=>{
            if (typeof res === 'string'){
              this.assignedTo = res
              return this.$store.dispatch('getAutoFloatByGroup').then(res=>this.floatAmount = res)
            }
          }).finally(() => this.loading = false)
    },

    setUserFloat(user) {
      return this.$store.dispatch('checkFloat', {
        user: user,
        device: this.set.PC
      }).then(() => {
        return this.$store.commit('setUserFloat', {
          user: user,
          device: this.set.PC,
          supervisor: 'Auto',
          float: this.floatAmount
        });
      })
    },

    startShift() {
      const amount = Number(this.floatAmount)
      if (this.floatAmount === '' || this.floatAmount === null || this.floatAmount === undefined || Number.isNaN(amount) || amount < 0) {
        return
      }
      this.loading = true;
      this.$emit('float-assigning', { loading: true, message: 'Verifying float...' });
      this.setFloat()
          .finally(() => {
            this.loading = false;
          });
    },

    setFloat() {
      this.$emit('float-assigning', { loading: true, message: 'Assigning float...' });
      return this.$store.dispatch('assignFloat', {
        user: this.assignedTo,
        amount: Number(this.floatAmount),
        authorisedBy: this.supervisorPassword,
      }).then(async (assigned) => {
        if (assigned) {
          this.$emit('float-assigning', { loading: true, message: 'Preparing POS...' });
          return this.$store.dispatch(`goToSales`)
        }
      }).finally(() => {
        this.$emit('float-assigning', { loading: false });
      })
    },

    updateDateTime() {
      const now = new Date()
      this.currentDate = now.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      this.currentTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    formatCurrency(value) {
      if (!value) return '$0.00'
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(value)
    },
  }
}
</script>

<style scoped>
.btn {
  background: var(--secondary-button-bg, #1e88e5);
  color: var(--secondary-button-text, white);
  font-weight: 600;
  display: block;
  height: 45px;
  flex: 1;
}

.submit-btns {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  max-width: 400px;
  width: 95vw;
  position: relative;
}

.form-floating input {
  background: var(--card-bg);
  border: var(--card-border);
  color: var(--text-primary);
}

.form-floating input:focus {
  background: var(--card-bg);
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.form-floating label {
  color: var(--text-secondary);
}
</style>
